import React from "react";
import Api from "../../Common/api.jsx";
import "./ExploreNfts.scss";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { Scrollbars } from "react-custom-scrollbars";
import { Link } from "react-router-dom";
import { max } from "moment";
import SkeletonProduct from "../../Pages/Skeleton/index.jsx";
import CommonHelper from "../../Helpers/CommonHelper.jsx";

export default class ExploreNfts extends React.Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.state = {
      filter: "",
      loader: false,
      SkelatonLoader:false,
      setFilter: "",
      assets: [],
      pageNumber: 1,
      pageSize: 20,

      status: false,
      minprice: null,
      maxPrice: null,
      chain: [],

      totalRecords: 0,
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener("click", () => {
      document.getElementsByClassName("search-autocomplete")[0].style.display =
        "none";
    });
    this.getAssets(null);
  }

  getAssets() {
    this.setState({ loader: true });
    const filter = {
      pagenumber: this.state.pageNumber,
      pagesize: this.state.pageSize,
      minprice: this.state.minprice,
      maxPrice: this.state.maxPrice,
      chain: this.state.chain,
    };

    //this.timeout = setTimeout(() => {
    new Api()
      .post("all_assets/", filter)
      .then((response) => {
        console.log(response.data);
        this.setState({
          assets: [...this.state.assets, ...response.data.assets],
          totalRecords: response.data.totalRecords,
        });
        this.setState({ loader: false });
        this.setState({SkelatonLoader:false});
       // clearTimeout(this.timeout);
      })
      .catch((err) => console.log(err));
    // }, 4000);

    this.applyFilter = true;
  }

 scrollToBottom = (id) => {
    const element = document.getElementById(id);
    element.scrollTop = element.scrollHeight;
 }

  loadMoreAssets(event) {
    //window.scrollTo(0, document.body.scrollHeight);
    event.preventDefault();
    this.setState({SkelatonLoader:true});
    var totalRecords = this.state.totalRecords;
    var totalPages = Math.ceil(totalRecords / this.state.pageSize);
    this.timeout = setTimeout(() => {
    if (this.state.pageNumber > totalPages) return;

    this.setState({ pageNumber: this.state.pageNumber + 1 }, () => {
      this.getAssets();
      const element = document.getElementById("skel");
      if(element!=null){
      element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
      }
      //this.scrollToBottom('skel')
    });
    clearTimeout(this.timeout);
    
  }, 1000);
  }

  toggleMoreButton() {
    var totalRecords = this.state.totalRecords;
    var totalPages = Math.ceil(totalRecords / this.state.pageSize);
    return this.state.pageNumber < totalPages;
  }

  unCheck(i) {
    let ref = "ref_" + i;
    this.refs[ref].checked = !this.refs[ref].checked;
  }

  getChainConfigs() {
    const chainConfigs = new CommonHelper().getAllChainConfigs();

    this.setState({ chainConfigs: chainConfigs });
  }

  handleChange(e) {
    console.log(e, e.target.name);
    this.setState({ [e.target.name]: e.target.value });
    console.log(this.state);
  }

  handleChangeCheck = (e) => {
    this.setState({ status: e.target.checked });
    console.log(e.target.checked);
  };

  setFilterData(e) {
    this.setState({ showVerifiedOnly: e.target.checked });
  }

  array = [];
  async setChainData(e) {
    console.log(e.target.checked, e.target.name, this.state.cha);
    if (e.target.checked) {
      this.array.push(e.target.name);
      await this.setState({ chain: [...new Set(this.array)] });
      console.log(this.state.chain);
    } else {
      this.array = this.array.filter(function (value, index, arr) {
        return value != e.target.name;
      });

      await this.setState({ chain: [...new Set(this.array)] });
    }
    console.log(this.state.chain);
  }

  setFilterCategoryData(id) {
    this.setState({ category_id: id, assets: [], totalRecords: 0 }, () => {
      this.getAssets();
      this.cancel(1);
    });
  }

  // explorrerCollection() {
  //   document.body.classList.toggle("filterActive", "filter");
  //   document
  //     .querySelector(".btn-show-filtetr")
  //     .classList.toggle("active", "filter");
  //   document
  //     .querySelector(".filter-list-box-wrap")
  //     .classList.toggle("filter-open", "filter");
  // }
  explorrerCollection() {
    document.body.classList.toggle("filterActive", "filter");
    document
      .querySelector(".btn-show-filtetr")
      .classList.toggle("active", "filter");
    document
      .querySelector(".filter-sidebar")
      .classList.toggle("filter-open", "filter");
  }

  cancel(flag) {
    document.body.classList.toggle("filter", "filterActive");
    document
      .querySelector(".btn-show-filtetr")
      .classList.toggle("filter", "active");
    document
      .querySelector(".filter-list-box-wrap")
      .classList.remove("filter-open");
    if (flag == 2) {
      //var x = document.getElementsByClassName("verifiedCheck");
      //this.refs["verifiedCheck"].checked = false; //this.refs['verifiedCheck'].checked;
      this.refs["Ethereum"].checked = false; //this.refs['ethereumCheck'].checked;
      this.refs["Polygon"].checked = false; //this.refs['polygonCheck'].checked;
      this.refs["Solana"].checked = false; //this.refs['solanaCheck'].checked;
      //x.checked = false;

      this.applyFilter = false;
      this.setState(
        {
          status: false,
          minprice: "",
          maxPrice: "",
          chain: [],
          category_id: null,
          assets: [],
          totalRecords: 0,
        },
        () => {
          this.getAssets();
          console.log("clear");
        }
      );
    }
  }

  async clearAll() {
    //this.refs["verifiedCheck"].checked = false; //this.refs['verifiedCheck'].checked;
    this.refs["Ethereum"].checked = false; //this.refs['ethereumCheck'].checked;
    this.refs["Polygon"].checked = false; //this.refs['polygonCheck'].checked;
    this.refs["Solana"].checked = false; //this.refs['solanaCheck'].checked;

    this.applyFilter = false;
    this.array = [];
    await this.setState({ chain: [] });
    this.setState(
      {
        status: false,
        minprice: "",
        maxPrice: "",
        chain: [],
        category_id: null,
        //showVerifiedOnly: false,
        isInvalidUser: false,
        assets: [],
        totalRecords: 0,
      },
      () => {
        this.getAssets();
        console.log("clear");
      }
    );
  }

  removeChain(flag) {
    console.log(this.state.chain[flag]);
    this.refs[this.state.chain[flag]].checked = false;
    var name = this.state.chain[flag];
    this.array = this.array.filter(function (value, index, arr) {
      return value != name;
    });
    this.setState({ chain: this.array });
  }

  removePrice() {
    this.setState(
      {
        minprice: "",
        maxPrice: "",
      },
      console.log("clear")
    );
  }

  render = () => {
    return (
      <>
        <Header />

        <div className="exploreCollections">
          <div className="container">
            <div className="section-title">
              <h2>Discover more NFTs</h2>
            </div>
            <div className="filter-wrap">
              <div className="filter-wrap__aside"></div>
              <div className="filter-wrap__aside full-width">
                {/* <button
                  className="button btn-show-filtetr"
                  onClick={() => this.explorrerCollection()}
                >
                  <div className="img-box">
                    <i className="material-icons-outlined">filter_list</i>
                  </div>
                  <span>Show Filters</span>
                </button> */}
                <button href="#" onClick={() => this.explorrerCollection()}  className="button btn-show-filtetr">
                  <i class="material-icons-outlined">filter_list</i> Show Filters</button>
              </div>
            </div>
            <div className="filter-sidebar">
              <Scrollbars className="custmScrollbar scrollbar-horizontal" >
                <div className="filter-list-box-wrap">
                  <div className="filter-box">
                    <div className="filter-title">
                      <h4>Applied Filters</h4>
                      <button className="clear-filter" onClick={() => this.clearAll()}>Clear All</button>
                    </div>
                    <ul className="applied-filter">
                      <li
                      style={{
                        display:
                          this.applyFilter &&
                          this.state.minprice != null &&
                          this.state.minprice != "" &&
                          this.state.maxPrice != null &&
                          this.state.maxPrice != ""
                            ? "inherit"
                            : "none",
                      }}
                      >
                        <span> {this.state.minprice} To {this.state.maxPrice}</span>
                        <a onClick={() => this.removePrice()}>
                          <img
                           onClick={() => this.removePrice()}
                            src="../images/svg/light-grey-cross.svg"
                            alt="clear filter"
                          />
                        </a>
                      </li>
                      
                      <li
                       style={{
                        display:
                          this.applyFilter && this.state.chain[0]
                            ? "inherit"
                            : "none",
                      }}
                      >
                        <span>{this.state.chain[0]}</span>
                        <a onClick={() => this.removeChain(0)}>
                          <img
                           onClick={() => this.removeChain(0)}
                            src="../images/svg/light-grey-cross.svg"
                            alt="clear filter"
                          />
                        </a>
                      </li>
                      
                      <li
                        style={{
                          display:
                            this.applyFilter && this.state.chain[1]
                              ? "inherit"
                              : "none",
                        }}
                      >
                        <span>{this.state.chain[1]}</span>
                        <a onClick={(e) => this.removeChain(1)}>
                          <img
                            onClick={(e) => this.removeChain(1)}
                            src="../images/svg/light-grey-cross.svg"
                            alt="clear filter"
                          />
                        </a>
                      </li>
                      
                      <li
                      style={{
                        display:
                          this.applyFilter && this.state.chain[2]
                            ? "inherit"
                            : "none",
                      }}
                      >
                        <span>{this.state.chain[2]}</span>
                        <a onClick={() => this.removeChain(2)}>
                          <img
                            onClick={() => this.removeChain(2)}
                            src="../images/svg/light-grey-cross.svg"
                            alt="clear filter"
                          />
                        </a>
                      </li>
                      
                    </ul>
                    {/* <div className="filter-title">
                      <h4>Status</h4>
                    </div> */}
                    {/* <ul className="filter-check-list">
                      <li>
                        <label htmlFor="buyNow">
                          <input
                            type="checkbox"
                            id="buyNow" 
                            hidden
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          <span>Buy Now</span>
                        </label>
                      </li>
                      <li>
                        <label htmlFor="onAuction">
                          <input
                            type="checkbox"
                            id="onAuction"
                            hidden 
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          <span>On Auction</span>
                        </label>
                      </li>
                      <li>
                        <label htmlFor="new">
                          <input
                            type="checkbox"
                            id="new"
                            hidden 
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          <span>New</span>
                        </label>
                      </li>
                      <li>
                        <label htmlFor="hasOffer">
                          <input
                            type="checkbox"
                            id="hasOffer"
                            hidden 
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          <span>Has Offer</span>
                        </label>
                      </li>
                    </ul> */}
                    <div className="filter-title">
                      <h4>Price (in ETH)</h4>
                    </div>
                    <div className="price-range">
                      <input
                        type="text"
                        name="minprice"
                        id="min"
                        placeholder="min"
                        className="min"
                        value={this.state.minprice}
                          onChange={(e) => {
                            this.handleChange({
                              target: {
                                name: e.target.name,
                                value: e.target.value,
                              },
                            });
                          }}
                      />
                      <span>to</span>
                      <input
                        type="text"
                        name="maxPrice"
                        id="max"
                        placeholder="max"
                        className="max"
                        value={this.state.maxPrice}
                        onChange={(e) => {
                          this.handleChange({
                            target: {
                              name: e.target.name,
                              value: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>
                    <div className="filter-title">
                      <h4>Blockchains</h4>
                    </div>
                    <ul className="filter-check-list">
                      <li>
                        <label htmlFor="ethereum">
                          <input
                            type="checkbox"
                            id="ethereum"
                            hidden
                            //defaultChecked
                            ref="Ethereum"
                            name="Ethereum"
                            onChange={(e) => this.setChainData(e)}
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          
                          <span><div className="icon">
                            <img src="../images/coin/eth.png" alt="Verify" />
                          </div> Ethereum</span>
                        </label>
                      </li>
                      <li>
                        <label htmlFor="polygon">
                          <input
                            type="checkbox"
                            id="polygon"
                            hidden
                            //defaultChecked
                            ref="Polygon"
                            name="Polygon"
                            onChange={(e) => this.setChainData(e)}
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          
                          <span><div className="icon">
                            <img src="../images/coin/poly.png" alt="Verify" />
                          </div> Polygon</span>
                        </label>
                      </li>
                      <li>
                        <label htmlFor="solana">
                          <input
                            type="checkbox"
                            id="solana"
                            hidden
                            //defaultChecked
                            ref="Solana"
                            name="Solana"
                            onChange={(e) => this.setChainData(e)}
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          
                          <span><div className="icon">
                            <img src="../images/coin/sola.png" alt="Verify" />
                          </div>Solana</span>
                        </label>
                      </li>
                    </ul>
                    <div className="filter-title">
                      <h4>Verification</h4>
                    </div>
                    <ul className="filter-check-list">
                      <li>
                        <label htmlFor="verified">
                          <input
                            type="checkbox"
                            id="verified"
                            ref="verifiedCheck"
                            hidden
                            onChange={(e) => this.setFilterData(e)}
                          />
                          <div className="img-box">
                            <img
                              src="../images/svg/check-blue.svg"
                              alt="check"
                            />
                          </div>
                          
                          <span><div className="icon">
                            <img src="../images/verify.png" alt="Verify" />
                          </div> Show only verified</span>
                        </label>
                      </li>
                    </ul>
                    <div className="filter-btn-wrap">
                      <button className="button" onClick={() => this.searchAssets()}>
                        Apply</button>
                      <button className="button purple-outline" 
                      onClick={() => this.explorrerCollectionClose(2)}> Cancel </button>
                    </div>
                  </div>
                </div>
              </Scrollbars> 
            </div>
            <div className="container">
              <div className="filter-list-box-wrap d-inline-block">
                {!this.state.loader ? (
                  <ul className="explore-nfts collection-details">
                    {this.state.assets?.length > 0 ?( this.state.assets.map((explores,index) => (
                      <li>
                        <Link
                          to={"../NftDetails/?assetId=" + explores.asset_id}
                          className="card"
                        >
                          <div className="card-img" id={'div_'+index}>
                            <img src={explores.asset_image} alt="discover" />
                          </div>
                          <div className="card-body">
                            <div className="artist-block">
                              <div className="media">
                                <div className="media-body">
                                  <div className="media-body__left">
                                    <label title={explores.asset_name}>
                                      {explores.asset_name.length <= 15
                                        ? explores.asset_name
                                        : explores.asset_name.substring(0, 15) +
                                          ".."}
                                    </label>
                                  </div>
                                  <div className="media-body__right">
                                    <label>
                                      <span>Last</span>{" "}
                                      <img src="../images/eth.png" alt="eth" />{" "}
                                      {explores.price}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </li>
                    )))
                    :(<li className="no-items-msg">
                    <h3>No Items</h3>                     
                   </li>)}
                  </ul>
                ) : (
                  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11,12].map((loading) => (
                    <>
                      <div className="skeleton-items" key={loading}>
                        <SkeletonProduct />
                      </div>
                    </>
                  ))
                )}

                    {this.state.SkelatonLoader ? 
                          [1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11,12].map((loading) => (
                            <>
                              <div className="skeleton-items" key={loading}>
                                <SkeletonProduct />
                              </div>
                            </>
                          ))
                          : ''
                    }

            
              </div>
              <div className="button-wrap" >
                {this.toggleMoreButton() ? (
                  <button id="skel"
                    onClick={(event) => this.loadMoreAssets(event)}
                    className="button purple-outline"
                  >
                    More Nfts
                  </button>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  };
}
